import * as React from 'react';
import { Layout } from './components/Layout';
import { PublicationPriceContainer } from './components/PublicationPrice';
import { RecommendedPackagesContainer } from './components/RecommendedPackages';
import { PackagePaymentStatusContainer } from './components/PackagePaymentStatus';
import { useSelector } from 'react-redux';
import { AvailablePackagesContainer } from './components/Packages';
import { selectIsRecommendedPackagesAvailable } from '../../../../reducers/v2/recommendedPackages/selectors';
import { selectIsPackagesAvailable } from '../../../../reducers/v2/publicationPackages/selectors';
import { Restrictions } from './components/Restrictions';
import { selectIsPublicationAllowed } from '../../../../reducers/v2/paidPublication/selectors';

export const PublicationSectionContainer = () => {
  const isRecommendedPackagesAvailable = useSelector(selectIsRecommendedPackagesAvailable);
  const hasPackage = useSelector(selectIsPackagesAvailable);
  const isPublicationAllowed = useSelector(selectIsPublicationAllowed);

  return (
    <Layout
      price={!isRecommendedPackagesAvailable && <PublicationPriceContainer />}
      packages={hasPackage && <AvailablePackagesContainer />}
      recommendedPackages={<RecommendedPackagesContainer />}
      recommendedPackagePaymentStatus={<PackagePaymentStatusContainer />}
      restrictions={!isPublicationAllowed && <Restrictions />}
    />
  );
};
